import { Component, OnInit, computed, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AuthService } from '../../auth/auth.service';

@Component({
	selector: 'app-header',
	imports: [MatToolbarModule, MatMenuModule, MatIconModule, MatButtonModule, MatDividerModule],
	templateUrl: './header.component.html',
	styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
	isMobile = input(false);
	menuClick = output<void>();

	private authService = inject(AuthService);
	loggedIn = this.authService.loggedIn;
	userInfo = this.authService.userInfo;
	userGroups = this.authService.userGroups;
	displayName = computed(() => {
		const info = this.userInfo();
		const fullName = `${info?.firstName ?? ''} ${info?.lastName ?? ''}`.trim();
		return fullName || info?.email || '';
	});

	constructor() { }

	async ngOnInit() {
		await this.authService.refreshAuthState();
		if (this.loggedIn()) {
			const userToken = await this.authService.getToken();
			console.log('getToken():', userToken);
		}
	}

	async signOut() {
		await this.authService.logOut();
	}
}
